import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";

import {
  ApprovalWorkFlowDataSchemaObj,
  CategoryList,
  FieldList,
  FrequecyCountMap,
  FrequencyDataObj,
} from "../../utils/constant";
import { getFieldInfoListFromGetJSonSchema } from "../../utils/helper";
import PreviewForm from "./PreviewForm";
import EnhancedPreviewForm from "./EnhancedPreviewForm";
import { FaChevronDown } from "react-icons/fa";
import {
  UpdateOneData,
  UpdateSingleCollectionData,
  getDataWithFilterUrl,
  getSingleCollectionData,
} from "../../controllers/APIController";
// import { logMetricUpdated } from "../../utils/auditLogger";
import AddModal from "./AddModal";
import FieldInfoTable from "./FieldInfoTable";
import { useNavigate, useParams } from "react-router-dom";
import AddFormulaModal from "./AddFormulaModal";
import FormulaInfoTable from "./FormulaInfoTable";
import {
  CustomFrequencyInput,
  DropDownInput,
  MultiSelectInput,
} from "./InputField/InputField";
import MetricTagInput from "./InputField/MetricTagInput";
import useGetAllModels from "../../hooks/useGetAllModels";
import {
  getAllApproverOfOrgnization,
  getAllReviewerOfOrgnization,
  getAllUserOfOrgnization,
} from "../../utils/helper";
import {
  ApproverUserSchemaObj,
  AssignedToUserSchemaObj,
  ReviewerUserSchemaObj,
  sectorSchema,
} from "../../constant/FormBuilder/FormBuilderConstant";
import useGetSectorName from "../../hooks/useGetSectorName";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import FrameworFieldAccodian from "./FrameworFieldAccodian";
import {
  getJSonSchemaFromFieldInfoList,
  getLinkJsonReponse,
  generateUniqueId,
} from "../../utils/frombuilder.utils";

const initialFormData = {
  metricName: "",
  categoryName: "",
  className: "",
  description: "",
  frameWork: [],
  SectorText: "",
  formulaeAIText: "",
  ApprovalWorkFlow: "",
};

const fieldListValues = Object.keys(FieldList).map((key) => {
  return [key, FieldList[key]];
});

const getLinkInfoListFromJson = (list) => {
  const response = [];

  list.forEach((item) => {
    response.push({
      id: item.id,
      Title: item.name,
      link: item.link,
      Type: "link",
      name: "link",
    });
  });
  return response;
};

const UIMetricBuilderValidation = (formData, fieldInfoList, requiredArr) => {
  const err = {};
  let isValid = true;

  if (fieldInfoList.length === 0) {
    err["BuildData"] = "Build Data should have atleast one field";
    isValid = false;
  }

  Object.keys(formData).map((key) => {
    if (requiredArr.includes(key) && formData[key] === "") {
      err[key] = `${key} is required`;
      isValid = false;
    }
  });
  return { isValid: isValid, error: err };
};

const EditAIFormBuilder = () => {
  const { allModels, setAllModels } = useGetAllModels();

  const [formData, setFormData] = useState(initialFormData);
  const [jsonData, setJsonData] = useState("");

  const { allSectorName } = useGetSectorName();
  
  // Set default sector when sectors are loaded (only if not already set from API)
  useEffect(() => {
    if (allSectorName?.length && !formData.SectorText) {
      const generalSector = allSectorName.find(sector => 
        sector.name?.toLowerCase() === "general"
      );
      const defaultSector = generalSector || allSectorName[0];
      if (defaultSector) {
        setFormData(prev => ({
          ...prev,
          SectorText: defaultSector.name
        }));
      }
    }
  }, [allSectorName, formData.SectorText]);
  const { OrgDetail: DefaultOrgDetail } = useGetDefaultOrg();

  const [sectionText, setSectorText] = useState("");
  const [frameWorkList, setFrameWorkList] = useState([]);
  const [frameWorkDetails, setFrameWorkDetails] = useState({});
  const [MetricNameList, setMetricNameList] = useState({});
  const [overviewList, setOverviewList] = useState({});
  const [guidanceList, setGuidanceList] = useState({});

  const requiredArr = ["metricName", "categoryName", "jsonSchema"];
  const [validationErrors, setValidationErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});

  const [fieldType, setFieldType] = useState("");
  const [fieldInfoList, setFieldInfoList] = useState([]); // JsonSchema Input field info
  const [LinkInfoList, setLinkInfoList] = useState([]); // Link field info in Metric
  const [selectedFormulaList, setSelectedFormulaList] = useState([]);

  const [FormulaInfoList, setFormulaInfoList] = useState([]); // Formula field info in Metric

  // const [frequency, setFrequency] = useState("");

  const [frequency, setFrequency] = useState(FrequencyDataObj?.values[0]?.name);
  const [customFrequency, setCustomFrequency] = useState(0.01);

  const showCustomFrequencyInput = frequency === "Custom";

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const UserId = UserLogged && UserLogged?.user?.id;
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const userRole = UserLogged && UserLogged.user.userRole;

  const navigate = useNavigate();

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isOpenLink,
    onOpen: onOpenLink,
    onOpenChange: onOpenChangeLink,
  } = useDisclosure();

  const {
    isOpen: isOpenFormula,
    onOpen: onOpenFormula,
    onOpenChange: onOpenChangeFormula,
  } = useDisclosure();

  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [tagsValidation, setTagsValidation] = useState("");

  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
  const [selectedApproverTo, setSelectedApproverTo] = useState([]);
  const [selectedReviewerTo, setSelectedReviewerTo] = useState([]);
  const [AllUserList, setAllUserList] = useState([]);
  const [AllApproverList, setAllApproverList] = useState([]);
  const [AllReviewerList, setAllReviewerList] = useState([]);

  // State for dynamic categories
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  const { _id, _orgId } = useParams();
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  // Fetch categories from metrics API
  useEffect(() => {
    const fetchCategories = async () => {
      if (!OrgInfo) return;
      
      setIsLoadingCategories(true);
      try {
        const data = await getDataWithFilterUrl("metrics", orgFilterUrl);
        const metricsList = data?.data || [];
        
        // Extract unique categories from metrics data
        const uniqueCategories = [...new Set(
          metricsList.map(item => item?.attributes?.Category).filter(Boolean)
        )].sort();
        
        // Convert to the format expected by the dropdown
        const categoriesList = uniqueCategories.map((category, index) => ({
          id: (index + 1).toString(),
          name: category,
        }));
        
        setDynamicCategories(categoriesList);
      } catch (error) {
        console.error("Error fetching categories:", error);
        // Fallback to hardcoded categories if API fails
        setDynamicCategories(CategoryList);
      } finally {
        setIsLoadingCategories(false);
      }
    };

    fetchCategories();
  }, [OrgInfo, orgFilterUrl]);

  const changeHandler = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
  const handleJsonChange = (editor, data, value) => {
    setJsonData(value);
  };

  const showPreviewHandler = () => {
    setShowPreview(false);
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    setValidationErrors(validationResponse.error);
    if (!validationResponse.isValid) {
      return;
    }

    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );

    const frameWorkResponse = {
      id: formData?.frameWork || [],
    };
    const publishData = {
      Name: formData.metricName,
      Category: formData.categoryName,
      ClassName: formData.className,
      Description: formData.description,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      Frequency: frequency,
    };

    setPreviewData(publishData);
    setShowPreview(true);
  };
  const submitHandler = async () => {
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr
    );

    if (!validationResponse.isValid) {
      setValidationErrors(validationResponse.error);
      return;
    }
    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = {
      id: formData?.frameWork || [],
    };
    const AssignedToData = selectedAssignedTo?.map((id) => +id);
    const ApproverToData =
      formData?.ApprovalWorkFlow === "1-Step Approval" ||
      formData?.ApprovalWorkFlow === "2-Step Approval"
        ? selectedReviewerTo?.map((id) => +id)
        : [];
    const ReviewerToData =
      formData?.ApprovalWorkFlow === "2-Step Approval"
        ? selectedApproverTo?.map((id) => +id)
        : [];
    const publishData = {
      Name: formData?.metricName,
      Category: formData?.categoryName,
      ClassName: formData?.className,
      Description: formData?.description,
      Framework: frameWorkResponse,
      WorkFlow: formData?.ApprovalWorkFlow,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      Frequency: frequency,
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      TagList: tags,
      AssignedTo: AssignedToData,
      ApproverTo: ApproverToData,
      ReviewerTo: ReviewerToData,
    };

    let result = await UpdateOneData("metrics", _id, publishData);

    // Log the metric update for audit purposes
    // try {
    //   await logMetricUpdated(
    //     _id,
    //     formData?.metricName || "Unknown Metric",
    //     {
    //       category: formData?.categoryName,
    //       className: formData?.className,
    //       workflow: formData?.ApprovalWorkFlow,
    //       frequency: frequency,
    //       tags: tags,
    //       organizationId: _orgId,
    //       builderType: "AI"
    //     }
    //   );
    // } catch (error) {
    //   console.error("Error logging metric update:", error);
    // }

    const newTags = tags?.filter((name) => !allTags?.includes(name));
    const updatedTags = [...allTags, ...newTags];
    await UpdateSingleCollectionData("tag", { List: updatedTags });

    navigate(`/${_orgId}/metrics-builder`);
    window.location.reload();
  };

  const addFieldHandler = (listItem) => {
    // Ensure new fields get proper displayOrder
    const newField = {
      ...listItem,
      displayOrder: fieldInfoList.length
    };
    setFieldInfoList([...fieldInfoList, newField]);
  };
  const addLinkHandler = (listItem) => {
    setLinkInfoList([...LinkInfoList, listItem]);
  };
  const addFormulaHandler = (listItem) => {
    setFormulaInfoList([...FormulaInfoList, listItem]);
  };

  useEffect(() => {
    const filteredUrl = `${orgFilterUrl}&filters[Category][$eqi]=framework`;
    getDataWithFilterUrl("frameworks")
      .then((data) => {
        let frameWorkData = data.data;
        const f = {};
        frameWorkData = frameWorkData?.map((item) => {
          f[item.id] = item.attributes.Name;
          return { id: item.id, name: item?.attributes?.Name };
        });
        setFrameWorkDetails(f);
        setFrameWorkList(frameWorkData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const filteredUrl = `filters[id][$eqi]=${_id}`;
    getDataWithFilterUrl("metrics", filteredUrl)
      .then((data) => {
        let response = data.data[0];

        setFormData({
          metricName: response?.attributes?.Name || "",
          categoryName: response?.attributes?.Category || "",
          className: response?.attributes?.ClassName || "",
          description: response?.attributes?.Description || "",
          frameWork: response?.attributes?.Framework?.id || [],
          ApprovalWorkFlow: response?.attributes?.WorkFlow,
          SectorText: response?.attributes?.Sector || "",
          formulaeAIText:
            response?.attributes?.JsonSchema?.formulaeAIText || "",
        });
        const AssignedToData = response?.attributes?.AssignedTo?.data?.map(
          (user) => user?.id?.toString()
        );
        const ApproverToData = response?.attributes?.ApproverTo?.data?.map(
          (user) => user?.id?.toString()
        );
        const ReviewerToData = response?.attributes?.ReviewerTo?.data?.map(
          (user) => user?.id?.toString()
        );
        setSelectedAssignedTo(AssignedToData);
        setSelectedApproverTo(ApproverToData);
        setSelectedReviewerTo(ReviewerToData);

        const frequencyNumber = +response?.attributes?.FrequencyValue;
        const frequencyval =
          frequencyNumber === -1
            ? "Custom"
            : frequencyNumber === 30
            ? "Every month"
            : frequencyNumber === 7
            ? "Every week"
            : frequencyNumber === 1
            ? "Everyday"
            : "Only Once";

        setFrequency(frequencyval);

        setFieldInfoList(
          getFieldInfoListFromGetJSonSchema(
            response?.attributes?.JsonSchema
          )
        );
        setLinkInfoList(
          getLinkInfoListFromJson(response?.attributes?.Links?.Links)
        );

        setFormulaInfoList(response?.attributes?.JsonSchema?.formula || []);
        setTags(response?.attributes?.TagList || []);
        let formulaList = response?.attributes?.JsonSchema?.formula || [];
        formulaList = formulaList.map((data) => data?.id?.toString());
        setSelectedFormulaList(formulaList);
        setOverviewList(response?.attributes?.Overview || {});
        setGuidanceList(response?.attributes?.Guidance || {});
        setMetricNameList(response?.attributes?.NameList || {});
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSingleCollectionData("tag")
      .then((data) => {
        setAllTags(data?.data?.attributes?.List);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, []);

  useEffect(() => {
    const fun = async () => {
      let allUser = await getAllUserOfOrgnization();
      let allReviewer = await getAllReviewerOfOrgnization();
      let allApprover = await getAllApproverOfOrgnization();

      allUser = allUser?.map((user) => {
        return { id: user.id, name: user.username };
      });
      allReviewer = allReviewer?.map((user) => {
        return { id: user.id, name: user.username };
      });
      allApprover = allApprover?.map((user) => {
        return { id: user.id, name: user.username };
      });

      setAllUserList(allUser);
      setAllApproverList(allApprover);
      setAllReviewerList(allReviewer);
    };
    fun();
  }, []);

  return (
    <div className="flex items-start justify-between">
      <div className="flex flex-col w-full max-w-4xl mx-auto space-y-4">
        {/* Metric Name Input  */}
        <Input
          type="text"
          size="sm"
          variant="faded"
          isRequired
          label="Metric Name *"
          labelPlacement="outside"
          placeholder="Enter metric name"
          name="metricName"
          value={formData["metricName"]}
          onChange={changeHandler}
          isInvalid={validationErrors["metricName"]}
          errorMessage={
            validationErrors["metricName"] && validationErrors["metricName"]
          }
        />

        {/* Category DropDown */}
        <div className="flex flex-col gap-1 w-full">
          <label className="text-xs font-medium text-slate-700">
            Category *
          </label>
          {validationErrors["categoryName"] && (
            <p className="text-red-500 text-xs">{validationErrors["categoryName"]}</p>
          )}
          <Dropdown>
            <DropdownTrigger
              isInvalid={validationErrors["categoryName"]}
              errorMessage={
                validationErrors["categoryName"] &&
                validationErrors["categoryName"]
              }
              className="w-full"
            >
              <Button size="sm" variant="faded" className="w-full justify-between" isLoading={isLoadingCategories}>
                <span className="text-sm">
                  {isLoadingCategories ? "Loading categories..." : (formData.categoryName === "" ? "Select category" : formData.categoryName)}
                </span>
                <FaChevronDown className="text-xs" />
              </Button>
            </DropdownTrigger>
            <DropdownMenu
              aria-label="Static Actions"
              className="w-144"
              selectionMode="single"
              name="categoryName"
              style={{ zIndex: 9999 }}
              onSelectionChange={(event) => {
                setFormData({
                  ...formData,
                  categoryName: Array.from(event)
                    .join(", ")
                    .replaceAll("_", " "),
                });
              }}
            >
                                          {dynamicCategories.length > 0 && !isLoadingCategories ? (
                              dynamicCategories.map((item) => (
                                <DropdownItem key={item.id}>{item.name}</DropdownItem>
                              ))
                            ) : (
                              <DropdownItem key="loading" disabled>
                                Loading categories...
                              </DropdownItem>
                            )}
            </DropdownMenu>
          </Dropdown>
        </div>

        {/* ClassName Input */}
        <Input
          type="text"
          size="sm"
          variant="faded"
          label="Class Name"
          value={formData["className"]}
          placeholder="Enter class name"
          labelPlacement="outside"
          name="className"
          onChange={changeHandler}
        />

        {/* Description Input  */}
        <Textarea
          label="Description"
          labelPlacement="outside"
          variant="faded"
          value={formData["description"]}
          size="sm"
          minRows={2}
          placeholder="Enter metric description"
          name="description"
          onChange={changeHandler}
        />

        <Textarea
          size="sm"
          variant="faded"
          label="General Overview"
          labelPlacement="outside"
          placeholder="Enter general overview"
          minRows={2}
          value={overviewList["Generic"]}
          onChange={(event) =>
            setOverviewList({
              ...overviewList,
              Generic: event.target.value,
            })
          }
        />
        <Textarea
          size="sm"
          variant="faded"
          label="General Guidance"
          labelPlacement="outside"
          placeholder="Enter general guidance"
          minRows={2}
          value={guidanceList["Generic"]}
          onChange={(event) =>
            setGuidanceList({
              ...guidanceList,
              Generic: event.target.value,
            })
          }
        />
        {DefaultOrgDetail?.id === OrgInfo && (
          <DropDownInput
            data={{
              ...sectorSchema,
              values: allSectorName,
            }}
            value={formData.SectorText}
            validationErrors={validationErrors}
            onChangeHandler={(title, value, type) =>
              setFormData({ ...formData, SectorText: value })
            }
            buttonCSS="mb-2"
          />
        )}
        {/* FrameWork Input */}
        <Select
          label="Select Framework"
          placeholder="Select any Framework"
          variant="faded"
          selectionMode="multiple"
          labelPlacement="outside"
          size="sm"
                      selectedKeys={new Set((Array.isArray(formData["frameWork"]) ? formData["frameWork"] : []).filter(id => 
              frameWorkList?.some(item => item.id.toString() === id.toString())
            ) || [])}
          onSelectionChange={(event) => {
            setFormData({
              ...formData,
              frameWork: Array.from(event),
            });
          }}
        >
          {frameWorkList?.map((item) => (
            <SelectItem key={item.id} value={item.name} className="py-2">
              {item.name}
            </SelectItem>
          ))}
        </Select>

        {formData?.frameWork &&
          formData?.frameWork?.map((id) => {
            return (
              <FrameworFieldAccodian
                key={id}
                title={frameWorkDetails[+id]}
                setMetricNameList={setMetricNameList}
                MetricNameList={MetricNameList}
                setGuidanceList={setGuidanceList}
                guidanceList={guidanceList}
                setOverviewList={setOverviewList}
                overviewList={overviewList}
              />
            );
          })}

        {/* AssignedTo User DropDown */}
        <MultiSelectInput
          data={AssignedToUserSchemaObj}
          value={selectedAssignedTo}
          valuesList={AllUserList}
          onChangeHandler={(title, value, type) => setSelectedAssignedTo(value)}
        />

        {/* Approval Workfflow DropDown */}
        <DropDownInput
          buttonCSS={"mb-2"}
          data={ApprovalWorkFlowDataSchemaObj}
          value={formData?.ApprovalWorkFlow || ""}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              ApprovalWorkFlow: value,
            })
          }
        />

        {/* Approver User DropDown */}
        {(formData?.ApprovalWorkFlow === "1-Step Approval" ||
          formData?.ApprovalWorkFlow === "2-Step Approval") && (
          <MultiSelectInput
            data={ApproverUserSchemaObj}
            value={selectedApproverTo}
            valuesList={AllApproverList}
            onChangeHandler={(title, value, type) =>
              setSelectedApproverTo(value)
            }
          />
        )}

        {/* Reviewer User DropDown */}
        {formData?.ApprovalWorkFlow === "2-Step Approval" && (
          <MultiSelectInput
            data={ReviewerUserSchemaObj}
            value={selectedReviewerTo}
            valuesList={AllReviewerList}
            onChangeHandler={(title, value, type) =>
              setSelectedReviewerTo(value)
            }
          />
        )}

        <DropDownInput
          buttonCSS={"mb-2"}
          data={FrequencyDataObj}
          value={frequency}
          validationErrors={1}
          onChangeHandler={(title, value, type) => setFrequency(value)}
        />

        {showCustomFrequencyInput && (
          <CustomFrequencyInput
            value={customFrequency}
            onChangeHandler={(value) => setCustomFrequency(value)}
          />
        )}

        <MetricTagInput
          tags={tags}
          setTags={setTags}
          IntialvalidationError={tagsValidation}
          allTags={allTags}
        />

        {/* Formula Input */}
        <Textarea
          size="sm"
          variant="faded"
          label="Formulae"
          labelPlacement="outside"
          placeholder="Describe the Formulae that you want to be added."
          minRows={2}
          name="formulaeAIText"
          onChange={changeHandler}
          value={formData["formulaeAIText"]}
        />

        {/* <Select
            label="Select Formules"
            placeholder="Choose any Formules"
            variant="faded"
            selectionMode="multiple"
            labelPlacement="outside"
            className="my-8"
            selectedKeys={new Set(selectedFormulaList)}
            onSelectionChange={(event) => {
              setSelectedFormulaList(Array.from(event));
            }}
          >
            {allModels?.map((item) => (
              <SelectItem key={item.id} value={item.id} className="py-2">
                {item.title}
              </SelectItem>
            ))}
          </Select> */}

        {/* JsonSchema Input */}
        <div className="w-full min-h-80">
          <div className="flex items-center gap-3 mb-3">
            <h3 className="text-base font-semibold text-slate-900">Build your Metric Schema</h3>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-red-500 text-xs mb-2">{validationErrors["BuildData"]}</p>
          )}
          <p className="text-sm text-slate-600 mb-3">
            Choose a data type and begin building your metric forms.
          </p>

          <div className="flex justify-end mb-3">
            <Dropdown>
              <DropdownTrigger>
                <Button 
                  color="primary" 
                  size="sm"
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
                >
                  Add a new field
                </Button>
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                selectionMode="single"
                style={{ zIndex: 9999 }}
                onSelectionChange={(event) => {
                  const selectedKey = Array.from(event)[0];
                  // Ensure we have a valid field type
                  if (selectedKey && FieldList[selectedKey]) {
                    setFieldType(selectedKey);
                    onOpen();
                  } else {
                    console.error("Invalid field type selected:", selectedKey);
                  }
                }}
              >
                {fieldListValues.map(
                  (row) =>
                    row[1].name !== "linkUrl" && (
                      <DropdownItem key={row[0]} name={row[0]}>
                        {row[1].title}
                      </DropdownItem>
                    )
                )}
              </DropdownMenu>
            </Dropdown>
          </div>

          {isOpen && (
            <AddModal
              onSubmitHandler={addFieldHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpen}
              onOpen={onOpen}
              onOpenChange={onOpenChange}
              fieldType={fieldType}
              id={generateUniqueId('field')}
              frameWorkDetails={frameWorkDetails}
              frameWorkList={frameWorkList}
              existingFields={fieldInfoList}
            />
          )}

          <FieldInfoTable
            fieldInfoList={fieldInfoList}
            setFieldInfoList={setFieldInfoList}
            frameWorkDetails={frameWorkDetails}
            frameWorkList={frameWorkList}
            category={formData.categoryName}
          />
        </div>

        {/* Links Input */}
        {/*
        <div className="w-full min-h-80">
          <div className="flex items-center gap-3 mb-3">
            <h3 className="text-base font-semibold text-slate-900">Attach your reference links</h3>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-red-500 text-xs mb-2">{validationErrors["BuildData"]}</p>
          )}
          <p className="text-sm text-slate-600 mb-3">
            Attach reference links for users to fill your metrics easier
          </p>

          <div className="flex justify-end mb-3">
            <Button 
              color="primary" 
              size="sm" 
              onClick={() => onOpenLink()}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
            >
              Add a new link
            </Button>
          </div>

          {isOpenLink && (
            <AddModal
              onSubmitHandler={addLinkHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenLink}
              onOpen={onOpenLink}
              onOpenChange={onOpenChangeLink}
              fieldType="link"
              id={generateUniqueId('link')}
            />
          )}

          <FieldInfoTable
            fieldInfoList={LinkInfoList}
            setFieldInfoList={setLinkInfoList}
            headersList={["Name", "Link", ""]}
          />
        </div>
        */}

        {/* Formula Input */}
        <div className="w-full min-h-80">
          <div className="flex items-center gap-3 mb-3">
            <h3 className="text-base font-semibold text-slate-900">Design your Formula</h3>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-red-500 text-xs mb-2">{validationErrors["BuildData"]}</p>
          )}
          <p className="text-sm text-slate-600 mb-3">
            Design your formula to handle mathematical calculations like
            emissions, diversity and many more.
          </p>

          <div className="flex justify-end mb-3">
            <Button 
              color="primary" 
              size="sm" 
              onClick={() => onOpenFormula()}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
            >
              Add a new formula
            </Button>
          </div>

          {isOpenFormula && (
            <AddFormulaModal
              onSubmitHandler={addFormulaHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenFormula}
              onOpen={onOpenFormula}
              onOpenChange={onOpenChangeFormula}
              fieldType="formula"
              id={generateUniqueId('formula')}
            />
          )}

          <FormulaInfoTable
            fieldInfoList={FormulaInfoList}
            setFieldInfoList={setFormulaInfoList}
          />
        </div>

        {/* Preview,Submit button */}
        <div className="flex gap-4 justify-end w-full pt-6">
          <Button
            color="default"
            variant="bordered"
            size="sm"
            onClick={showPreviewHandler}
            className="px-6"
          >
            Preview
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={submitHandler}
            className={`px-6 bg-emerald-600 hover:bg-emerald-700 ${
              userRole !== "Admin" ? "pointer-events-none opacity-50" : ""
            }`}
          >
            Submit
          </Button>
        </div>
      </div>

      {/* Preview Card Open */}
      {showPreview && (
        <div className="flex flex-col items-center w-[48%]">
          <EnhancedPreviewForm data={previewData} fieldInfoList={fieldInfoList} />
        </div>
      )}
    </div>
  );
};

export default EditAIFormBuilder;
